import { Image } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"

import mezoLogo from "#/assets/mezo-lockup.svg"
import mezoLogoRed from "#/assets/mezo-logo-inline.svg"
import { routes } from "#/shared/constants"
import {
  SanityCmsDataType,
  useDAppRoute,
  useLandingRoute,
  useMobileScreen,
  useSanityCmsData,
} from "#/shared/hooks"
import LandingTopBanner from "#/ui/LandingPages/components/LandingBanner"
import AccountMenu from "#/ui-old/AccountMenu"

import HeaderWrapper from "./HeaderWrapper"

export default function Header() {
  const isMobileScreen = useMobileScreen()
  const isDAppRoute = useDAppRoute()

  const { isLandingHomeRoute, isLandingPageRoute } = useLandingRoute()

  type LandingPageData = {
    enableBanner?: boolean
    showCloseButton?: boolean
    bannerTitle?: string
    bannerButtonText?: string
    bannerButtonLink?: string
    bannerLevel?: "l1" | "l2" | "l3"
  }

  const { data: headerData, error: headerError } =
    useSanityCmsData<LandingPageData>(SanityCmsDataType.Header)

  if (!headerData || headerError) {
    return null
  }

  if (!isDAppRoute && isMobileScreen) return null

  let logoSrc = mezoLogo
  if (isLandingHomeRoute) {
    logoSrc = mezoLogoRed
  } else if (isLandingPageRoute) {
    logoSrc = mezoLogoRed
  }

  return (
    <>
      {(isLandingHomeRoute || isLandingPageRoute) && (
        <LandingTopBanner
          banner={headerData.enableBanner}
          closeButton={headerData.showCloseButton}
          title={headerData.bannerTitle}
          buttonText={headerData.bannerButtonText}
          buttonLink={headerData.bannerButtonLink}
          bannerLevel={headerData.bannerLevel}
        />
      )}
      <HeaderWrapper>
        <Link to={routes.LANDING} style={{ position: "relative", zIndex: 10 }}>
          <Image src={logoSrc} alt="Mezo Logo" />
        </Link>
        {!isMobileScreen && isDAppRoute && <AccountMenu />}
      </HeaderWrapper>
    </>
  )
}
